import { motion } from "framer-motion";
import SectionContainer from "../components/SectionContainer";
import FeatureCard from "../components/FeatureCard";
import LanguageToggle from "../components/LanguageToggle";
import PlatformIconGrid from "../components/PlatformIconGrid";
import ActionItemsMock from "../components/ActionItemsMock";
import FollowUpsMock from "../components/FollowUpsMock";

function CardHeading({ title, body }) {
  return (
    <div className="space-y-2 text-center">
      <h3 className="text-xl font-semibold tracking-tight text-neutral-900">{title}</h3>
      <p className="mx-auto max-w-xs text-sm text-neutral-500">{body}</p>
    </div>
  );
}

export default function FeaturesSection() {
  return (
    <SectionContainer id="features" className="py-20 sm:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-[clamp(1.6rem,3.5vw,2.5rem)] font-semibold tracking-tight text-neutral-900">
          Every call. Every action. Handled on Call.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-neutral-500 sm:text-base">
          Shadow doesn't just listen. It gets things done, while you're still talking.
        </p>
      </div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        transition={{ staggerChildren: 0.1 }}
        className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6"
      >
        {/* Card 1 — Action items */}
        <FeatureCard>
          <CardHeading
            title="Action items, handled on the call."
            body="Shadow detects commitments the moment they happen — and handles them before you hang up."
          />
          <div className="mt-auto pt-6">
            <ActionItemsMock />
          </div>
        </FeatureCard>

        {/* Card 2 — Languages */}
        <FeatureCard>
          <LanguageToggle />
          <div className="mt-auto pt-6">
            <CardHeading
              title="Speaks every language"
              body="60+ languages. Whatever you think in, Shadow understands."
            />
          </div>
        </FeatureCard>

        {/* Card 3 — Follow-ups */}
        <FeatureCard>
          <FollowUpsMock />
          <div className="mt-auto pt-6">
            <CardHeading
              title="Follow-ups that write themselves"
              body="Recap, action items, and next steps, drafted before you close the laptop."
            />
          </div>
        </FeatureCard>

        {/* Card 4 — Platforms */}
        <FeatureCard>
          <CardHeading
            title="Works with every meeting platform"
            body="Slack, Google Meet, Zoom, Microsoft Teams, Notion, and many more."
          />
          <div className="mt-auto px-2 pt-6 sm:px-4">
            <PlatformIconGrid />
          </div>
        </FeatureCard>
      </motion.div>
    </SectionContainer>
  );
}
